<template>
  <div class="d-flex justify-center align-center" style="min-height: 100vh; background: #f5f5f5;">
    <v-card width="400" class="pa-6">
      <v-card-title class="text-h5 text-center"><h1 class="text-h5 font-weight-regular">Reset Password</h1></v-card-title>

      <v-form ref="form" @submit.prevent="handleSubmit">
        <!-- New Password -->
         <!-- <v-text-field
          v-model="email"
          type="string"
          label="email"
          :rules="[v => !!v || 'Email is required']"
          class="mb-4"
          required
        /> -->
        
        <v-text-field
          v-model="password"
          type="password"
          label="New Password"
          :rules="passwordRules"
          class="mb-4"
          required
        />

        <!-- Confirm Password -->
        <v-text-field
          v-model="confirmPassword"
          type="password"
          label="Confirm Password"
          :rules="[
            v => !!v || 'Confirmation is required',
            v => v === password || 'Passwords do not match'
          ]"
          class="mb-4"
          required
        />

        <v-btn type="submit" color="primary" block>
          Reset Password
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { resetPassword } from '@/services/entityService'
import { usePathController } from '@/composables/usePathController'
import { useLoaderStore } from "@/store/loader"
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

const { goToLogin, goTo  } = usePathController()
const route = useRoute()
const loader = useLoaderStore()
const password = ref('')
const confirmPassword = ref('')
const resetToken = ref('')
const form = ref(null)

const passwordRules = [
  v => !!v || 'Password is required',
  v => v.length >= 8 || 'Minimum 8 characters',
  v => /[A-Z]/.test(v) || 'At least 1 uppercase letter required',
  v => /[a-z]/.test(v) || 'At least 1 lowercase letter required',
  v => /[0-9]/.test(v) || 'At least 1 number required'
]

onMounted(() => {
  resetToken.value = route.params.resetToken
})

const handleSubmit = async () => {
  const { valid } = await form.value.validate()
  if (!valid) return

  const payload = {
    password: password.value,
    resetToken: resetToken.value,
  }

  try {
    sendLog("debug", "attempt_reset_password", {isResetTokenPresent: !!resetToken.value})
    await resetPassword(password.value, null, resetToken.value)
    goToLogin()
    // TODO: replace with your API call
    // await axios.post('/reset-password', payload)
  } catch (err) {
    loader.setAlert( { message: err.message, type: "error", timeout: 5000 });
  }
}
</script>

<style scoped>
</style>
